
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { _AbcButtonComponent } from '@barthauer/abc/ui-components';
import { AbcPopupComponent } from '@barthauer/abc/ui-components/abc-popup';
import { FlexLayoutModule } from 'ngx-flexible-layout';

@Component({
    selector: 'confirmation-popup',
    templateUrl: './confirmation-popup.component.html',
    styleUrls: ['./confirmation-popup.component.scss'],
    imports: [_AbcButtonComponent, AbcPopupComponent, FlexLayoutModule]
})
export class ConfirmationPopupComponent {
  @ViewChild('popup') popupRef: AbcPopupComponent;

  @Input() title: string = '';
  @Input() message: string = '';
  @Input() primaryBtnText: string = '';
  @Input() secondaryBtnText: string = '';

  @Output() userDecision = new EventEmitter<boolean>();

  constructor() {}

  public open(): Promise<boolean> {
    return new Promise((resolve) => {
      this.popupRef.instance.show();

      this.handlePrimaryAction = () => {
        this.hidePopup();
        resolve(true);
      };

      this.handleSecondaryAction = () => {
        this.hidePopup();
        resolve(false);
      };
    });
  }

  protected handlePrimaryAction: () => void;

  protected handleSecondaryAction: () => void;

  private hidePopup(): void {
    this.popupRef.instance.hide();
  }
}
